<template>
    <CustomizerStepShell
        :builder-content-missing="builderContentMissing"
        :can-show-content="canShowContent"
        :model="model"
        :content="content"
        :api-key="apiKey"
        :custom-components="getRegisteredComponents()"
    />
</template>

<script>
import { captureCustomizerException } from "../../utils/sentry";
/* eslint-disable */
import builderIoMixin from "../../mixins/builderIoMixin";
import stepNavigationMixin from "../../mixins/stepNavigationMixin";
import cartMixin from "../../mixins/cartMixin";
import shareMixin from "../../mixins/shareMixin";
import CustomizerStepShell from "./CustomizerStepShell.vue";

export default {
    name: "StepOne",
    components: {
        CustomizerStepShell,
    },
    mixins: [builderIoMixin, stepNavigationMixin, cartMixin, shareMixin],
    methods: {
        handleBeforeLeave(to, from, next) {
            const isValidationFailed = this.validateCurrentStepAndShowMessage('stepOne', this.pageSettings.storageKey);
            
            // Abort instead of leaving the navigation pending, so router.push() settles.
            next(isValidationFailed ? false : undefined);
        },
    },
    mounted() {
        this.initializeBuilderContent("StepOne")
            .catch(error => {
                if (process.env.VUE_APP_DEV_MODE === "true") {
                    console.error("Error initializing StepOne", {
                        code: error?.code || "unknown",
                    });
                }
                captureCustomizerException(error, {
                    tags: { component: "StepOne", failure_reason: "step_initialization_failed" },
                });
            });
    },
    beforeRouteLeave(to, from, next) {
        this.handleBeforeLeave(to, from, next);
    },
};
</script>
